export class CulturalUsageTypeMapper {
    public static toLabel(type?: string | null): string {
        switch (type) {
            case 'rent': {
                return 'Mieten';
            }
            case 'borrow': {
                return 'Verleihen';
            }
            case 'exchange': {
                return 'Austauschen';
            }
            case undefined:
            case null:
            default:
                return '';
        }
    }
}
